export const ExistingItemHandling = {
  KeepExisting: 0,
  AddQuantityToExisting: 1,
  ReplaceExisting: 2,
  ReplaceExistingWithCombinedQuantity: 3
};
